import styled from "styled-components";
import { FC, ReactNode } from "react";

const Container = styled.div`
    z-index: 10000;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: #f9f1dd;
`;

export const FullScreenModal: FC<{ children: ReactNode; show: boolean }> = ({ children, show }) => {
    return <>{show && <Container>{children}</Container>}</>;
};
